/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// @mui material components
import Card from '@mui/material/Card';
import LinearProgress from '@mui/material/LinearProgress';

// Vision UI Dashboard PRO React components
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import VuiButton from 'components/VuiButton';

function ComplianceUpdate() {
  return (
    <Card sx={{ height: '100%', padding: '24px' }}>
      <VuiBox display="flex" flexDirection="column" height="100%">
        <VuiTypography variant="lg" color="white" fontWeight="bold" mb={2}>
          COMPLIANCE UPDATE
        </VuiTypography>
        <VuiBox flex={1} display="flex" flexDirection="column" justifyContent="center">
          <VuiBox mb={2}>
            <LinearProgress
              variant="determinate"
              value={62}
              sx={{
                height: '12px',
                borderRadius: '10px',
                backgroundColor: '#0F1535',
                '& .MuiLinearProgress-bar': {
                  borderRadius: '10px',
                  background: 'linear-gradient(90deg, #FFB547 0%, #FF6B9D 100%)',
                },
              }}
            />
          </VuiBox>
          <VuiBox display="flex" justifyContent="space-between" mb={2}>
            <VuiTypography variant="button" color="text" fontWeight="regular">
              5 DAYS REMAINING
            </VuiTypography>
            <VuiTypography variant="button" color="text" fontWeight="bold">
              62%
            </VuiTypography>
          </VuiBox>
          <VuiTypography variant="button" color="text" fontWeight="regular" mb={3}>
            XYZ.com has a poor compliance status. Out of 3,100 total takedowns sent, 5,000 takedowns have yet to been complied with.
          </VuiTypography>
          <VuiBox>
            <VuiTypography variant="caption" color="text" fontWeight="regular" mb={2}>
              Consider the platform as a candidate for enhanced litigation.
            </VuiTypography>
          </VuiBox>
          <VuiButton color="info" size="medium" sx={{ mt: 2 }}>
            VIEW
          </VuiButton>
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default ComplianceUpdate;
